export default "__VITE_ASSET__b6302397__"